var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card color_light",
    staticStyle: {}
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.$t('product.clientProductId')) + " :  "), _c('span', {
    staticClass: "textcolor"
  }, [_vm._v("  " + _vm._s(_vm.boxdata.productid) + " ")])]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(_vm.$t('orders.ean')) + " : "), _c('span', {
    staticClass: "textcolor"
  }, [_vm._v("  " + _vm._s(_vm.boxdata.ean))])]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.ProductName')) + " :"), _c('span', {
    staticClass: "textcolor"
  }, [_vm._v("  " + _vm._s(_vm.boxdata.productname))])]), _vm._v(" "), _c('div', [_vm._v("  " + _vm._s(_vm.$t('boxList.quantity')) + " :"), _c('span', {
    staticClass: "textcolor"
  }, [_vm._v("  " + _vm._s(_vm.boxdata.quantity))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-1"
  })])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46b7d334", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46b7d334","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common_components/singleBoxItem.vue
// module id = 2074
// module chunks = 0